import { getCustomerHistory, historyKey, normalizeHistoryArgs } from '../../thunk/customerHistory';
import type { CustomerHistoryEntry } from '../../thunk/customerHistory';
import { mockupEventId } from '../../../lib/mockupEvents';

const emptyEntry = (): CustomerHistoryEntry => ({
    items: [],
    totalCount: 0,
    page: 0,
    perPage: 0,
    status: 'idle',
    error: null,
});

const extraReducers = {
    [getCustomerHistory.pending as any]: (state, action) => {
        const key = historyKey(action.meta.arg);
        const prev: CustomerHistoryEntry = state.data[key] || emptyEntry();
        state.data[key] = { ...prev, status: 'loading', error: null };
        state.status = 'loading';
        state.error = null;
    },
    [getCustomerHistory.fulfilled as any]: (state, action) => {
        const key = historyKey(action.meta.arg);
        const args = normalizeHistoryArgs(action.meta.arg);
        const prev: CustomerHistoryEntry = state.data[key] || emptyEntry();
        const incoming = Array.isArray(action.payload?.result) ? action.payload.result : [];
        let items = incoming;
        if (args.page > 1) {
            // Appending a page: drop rows the earlier pages already hold (new uploads shift the offsets).
            const seen = new Set(prev.items.map((e) => String(mockupEventId(e))));
            items = [...prev.items, ...incoming.filter((e) => !seen.has(String(mockupEventId(e))))];
        }
        state.data[key] = {
            items,
            totalCount: Number(action.payload?.totalCount) || items.length,
            page: Number(action.payload?.page) || args.page,
            perPage: Number(action.payload?.perPage) || args.limit,
            status: 'resolved',
            error: null,
        };
        state.status = 'resolved';
    },
    [getCustomerHistory.rejected as any]: (state, action) => {
        const key = historyKey(action.meta.arg);
        const prev: CustomerHistoryEntry = state.data[key] || emptyEntry();
        state.data[key] = { ...prev, status: 'rejected', error: action.payload || 'Failed to load' };
        state.status = 'rejected';
        state.error = action.payload;
    },
};

export default extraReducers;
